import type { CustomerOption } from '@/api/cockpit';

export function buildCatalogCustomerOptions(
  options: readonly CustomerOption[],
  topCandidates: readonly { value: string }[],
): readonly CustomerOption[] {
  const topValues = new Set(topCandidates.map((candidate) => candidate.value));
  return options.filter((option) => !topValues.has(option.customerNumber));
}
